import { render, staticRenderFns } from "./ModalSelecaoControles.vue?vue&type=template&id=2bfed38a&scoped=true&"
import script from "./ModalSelecaoControles.vue?vue&type=script&lang=js&"
export * from "./ModalSelecaoControles.vue?vue&type=script&lang=js&"
import style0 from "./ModalSelecaoControles.vue?vue&type=style&index=0&id=2bfed38a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfed38a",
  null
  
)

export default component.exports